// src/components/dashboard/InstructorPanel.jsx
import React from "react";
import { Link } from "react-router-dom";

/**
 * Student-only: "Message My Instructor" panel + card.
 */
const InstructorPanel = ({
  instructor,
  instructorName,
  instructorAvatar,
  studentUnreadCount = 0,
}) => {
  return (
    <div className="dash-panel">
      <h2 className="dash-panel-title">Message My Instructor</h2>
      <p className="dash-panel-subtitle">Ask questions, submit work, and get direct feedback.</p>

      <Link
        to="/messages"
        state={{
          recipientId: instructor?._id || instructor?.id,
          recipientFirstName: instructor?.firstName || instructor?.first_name,
          recipientLastName: instructor?.lastName || instructor?.last_name,
          recipientAvatarUrl: instructorAvatar,
        }}
        className="dash-instructor-card"
      >
        <div className="dash-instructor-avatar">
          <div className="dash-avatar-orb dash-avatar-orb-small">
            <div className="dash-avatar-face">
              {instructorAvatar ? (
                <img src={instructorAvatar} alt={instructorName} />
              ) : (
                <span className="dash-avatar-initials">{String(instructorName || "I").charAt(0).toUpperCase()}</span>
              )}
            </div>

            <div className="dash-avatar-ring" />
            {studentUnreadCount > 0 && <span className="dash-instructor-unread-dot" />}
          </div>
        </div>

        <div className="dash-instructor-info">
          <div className="dash-instructor-name">{instructorName}</div>
          <div className="dash-instructor-role">Master Artist • COSMETINK ACADEMY</div>

          <div className="dash-instructor-cta">
            Open messages →
            {studentUnreadCount > 0 && <span className="dash-instructor-unread-text">New message</span>}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default InstructorPanel;
